import { render, staticRenderFns } from "./wageComparisonColumnsList.vue?vue&type=template&id=8b516372&scoped=true&"
import script from "./wageComparisonColumnsList.vue?vue&type=script&lang=js&"
export * from "./wageComparisonColumnsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b516372",
  null
  
)

export default component.exports